export default __webpack_public_path__ + "static/media/logo-white.d1e7fe90.png";